const paths = {
    plotsMap: {
        root: '/farms',
        plotSummary: (orgId, id) => `/farms/${orgId}/plots/${id}`,
        plotForecast: (orgId, id) => `/farms/${orgId}/plots/${id}/forecasts`,
        plotHistory: (orgId, id) => `/farms/${orgId}/plots/${id}/history`,
        plotAlerts: (orgId, id) => `/farms/${orgId}/plots/${id}/alerts`,
        stationSummary: (orgId, id) => `/farms/${orgId}/stations/${id}`,
        stationForecast: (orgId, id) => `/farms/${orgId}/stations/${id}/forecasts`,
        stationHistory: (orgId, id) => `/farms/${orgId}/stations/${id}/history`,
        stationAlerts: (orgId, id) => `/farms/${orgId}/stations/${id}/alerts`
    },
    /** aka weather map */
    devicesMap: {
        root: '/weather-map',
        deviceSummary: (id) => `/weather-map/${id}`,
        deviceForecast: (id) => `/weather-map/${id}/forecasts`,
        deviceHistory: (id) => `/weather-map/${id}/history`,
        deviceAlerts: (id) => `/weather-map/${id}/alerts`
    },
    me: {
        account: '/me/account',
        profile: '/me/profile',
        preferences: '/me/preferences',
        notificationPreferences: '/me/preferences/notifications',
        allowedDevices: '/me/mobile-devices',
        receivedInvitations: '/me/invitations',
        featureToggle: '/me/feature-toggle',
        debug: '/me/debug',
        clusterSettings: '/me/cluster-settings',
        externalConnections: '/me/external-connections',
        api: '/me/api'
    },
    admin: {
        /** @deprecated remove with redesign */
        plotSettings: (orgId, plotId) => `/farms/${orgId}/admin/org-plots/${plotId}`,
        deviceSettings: (orgId, deviceId) => `/farms/${orgId}/admin/devices/${deviceId}`,
        /** @deprecated remove with redesign */
        stationSettings: (orgId, stationId) => `/farms/${orgId}/admin/stations/${stationId}`
    },
    alerts: {
        root: '/alerts',
        create: '/alerts/create',
        alertDetails: (alertId) => `/alerts/${alertId}`
    }
};
export default paths;
